import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "bg-back" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { style: {} }

import { ref, computed } from 'vue';
import { getDefaultRewards } from '@/utils/commonFunction';
import { ReturnTurnOverData } from '@/view/returnTurnover/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import CashbackNotice from '../components/common/cashbackNotice.vue';
import CashBackCard from '../components/common/cashBackCard.vue';
import CashbackWeekDetails from '../components/common/cashbackWeekDetails.vue';
import CashbackHistoryPopup from '../components/common/cashbackHistoryPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'returnTurnover',
  props: {
    dataSet: {}
  },
  emits: ['scrollLeft', 'scrollRight', 'getNextPageRewardData', 'getClaim', 'getHistoryList', 'resetHistoryData'],
  setup(__props: any, { emit: __emit }) {

const histryPopupRef = ref()

const formattedMessages = computed(() =>
    props.dataSet.activityDescription.map(msg => msg.replace(/\\n/g, '\n'))
);

const props = __props

const emits = __emit

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}

const getClaim = () => {
    emits('getClaim')
}

const getHistoryList = () => {
    emits('getHistoryList')
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.return_turnover'),
      "show-history": true,
      onOpenHistoryPopup: openHistoryPopup
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "bg-top-img",
        src: _ctx.dataSet.bannerIcon
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataSet.showLeft)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_0,
              style: {"width":"5%","position":"absolute","top":"2vh","z-index":"200"},
              onClick: scrollLeft
            }))
          : _createCommentVNode("", true),
        (_ctx.dataSet.showRight)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_0,
              onClick: scrollRight,
              style: {"width":"5%","position":"absolute","transform":"rotate(180deg)","right":"0","top":"2vh","z-index":"200"}
            }))
          : _createCommentVNode("", true),
        _createVNode(CashbackNotice, { content: formattedMessages.value }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CashBackCard, {
            title: _ctx.$t('common.bets'),
            "create-date": _ctx.dataSet.todayBetDetails?.createTime,
            day: _ctx.dataSet.todayBetDetails?.dayCount,
            showClickButton: _ctx.dataSet.availableGiftAmount > 0,
            "available-value": _ctx.dataSet.availableGiftAmount,
            "given-value": _ctx.dataSet.claimGiftAmount,
            onGetClaim: getClaim,
            dayList: _ctx.dataSet.futureRewards.length <= 0 ? _unref(getDefaultRewards)(_ctx.dataSet.dayCountVal) : _ctx.dataSet.futureRewards
          }, null, 8, ["title", "create-date", "day", "showClickButton", "available-value", "given-value", "dayList"])
        ]),
        _createVNode(CashbackWeekDetails, {
          "bet-list": _ctx.dataSet.weeklyRewardList,
          title: _ctx.$t('activity.bettingAmount'),
          type: "TURNOVER",
          todayDayRewards: _ctx.dataSet.todayDayRewards,
          "cashback-total": _ctx.dataSet.cashbackTotal,
          isShowTodayCard: _ctx.dataSet.isHaveTodayDayRewards,
          "istoday-claimed": _ctx.dataSet.todayBetDetails?.remainGiftAmount > 0
        }, null, 8, ["bet-list", "title", "todayDayRewards", "cashback-total", "isShowTodayCard", "istoday-claimed"]),
        _createVNode(CashbackHistoryPopup, {
          ref_key: "histryPopupRef",
          ref: histryPopupRef,
          onGetHistoryList: getHistoryList,
          list: _ctx.dataSet.historyList,
          onUpdateHistoryList: getNextPageRewardData,
          showIcon: _ctx.dataSet.total > _ctx.dataSet.pageSize * _ctx.dataSet.pageNum,
          title: _ctx.$t('activity.bettingAmount'),
          onResetHistoryData: resetHistoryData
        }, null, 8, ["list", "showIcon", "title"])
      ])
    ])
  ], 64))
}
}

})